import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Settings, ArrowDownCircle, CheckSquare, Bell, BarChart2, PieChart } from "react-feather";
import { useTheme } from "../theme/ThemeContext";
import WalletOutIcon from "./WalletOutIcon";
import MoneyInOutIcon from "./MoneyInOutIcon";

const Sidebar = ({ collapsed, isAdmin }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { tokens, fonts } = useTheme();

const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: <Home size={20} />, path: "/" },
    { id: "transactions", label: "Transactions", icon: <MoneyInOutIcon size={20} />, path: "/transactions" },
    { id: "income", label: "Income", icon: <ArrowDownCircle size={20} />, path: "/income" },
    { id: "billsPayments", label: "Bill & Payments", icon: <WalletOutIcon size={20} />, path: "/bills-and-payments" },
    { id: "analysis", label: "Analysis", icon: <PieChart size={20} />, path: "/analysis" },
    { id: "actionItems", label: "Action Items", icon: <CheckSquare size={20} />, path: "/action-items" },
    { id: "tasks", label: "Tasks", icon: <Bell size={20} />, path: "/tasks" },
    { id: "settings", label: "Settings", icon: <Settings size={20} />, path: "/settings" },
    ...(isAdmin ? [{ id: "admin", label: "User analytics", icon: <BarChart2 size={20} />, path: "/admin" }] : []),
  ];

  return (
    <aside
      style={{
        ...styles.sidebar,
        width: collapsed ? "60px" : "250px",
        height: "calc(100vh - 60px)",
        top: "60px",
        backgroundColor: tokens.sidebarBg,
        borderRight: `1px solid ${tokens.sidebarBorder}`,
      }}
    >
      <nav>
        <ul style={styles.menuList}>
          {menuItems.map(({ id, label, icon, path }) => {
            const isActive = currentPath === path;

            return (
              <li
                key={id}
                style={{
                  ...styles.menuItem,
                  ...(isActive ? { backgroundColor: tokens.sidebarActiveBg, fontWeight: "700" } : {}),
                  justifyContent: collapsed ? "center" : "flex-start",
                  fontFamily: fonts.body,
                }}
                title={collapsed ? label : undefined}
              >
                <Link to={path} style={{ ...styles.link, color: tokens.sidebarText }}>
                  <span style={{ ...styles.iconWrapper, color: isActive ? tokens.accent : tokens.textMuted }}>{icon}</span>
                  {!collapsed && <span>{label}</span>}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

const styles = {
  sidebar: {
    position: "fixed",
    left: 0,
    paddingTop: "10px",
    boxSizing: "border-box",
    overflowY: "auto",
    transition: "width 0.3s ease, background-color 0.2s ease",
    zIndex: 1000,
  },
  menuList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    cursor: "pointer",
    fontSize: "15px",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  iconWrapper: {
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
  },
  link: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    width: "100%",
  },
};


export default Sidebar;
